// extracted by mini-css-extract-plugin
module.exports = {"content":"LayoutIndex__content___sQK7F","contentMain":"LayoutIndex__contentMain___3TXO-","pageMain":"LayoutIndex__pageMain___2tFAc"};